import { useState, useCallback } from "react";

export const useAlertModal = () => {
  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  const showAlert = useCallback((message) => {
    setAlertMessage(message);
    setIsAlertOpen(true);
  }, []);

  const closeAlert = useCallback(() => {
    setIsAlertOpen(false);
    setAlertMessage("");
  }, []);

  return {
    isAlertOpen,
    alertMessage,
    showAlert,
    closeAlert,
  };
};